import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X, Phone } from 'lucide-react';
import LocalizedLink from '@/i18n/LocalizedLink';
import LanguageSwitcher from '@/components/common/LanguageSwitcher';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/events', label: t('nav.eventsHub') },
    { to: '/insights', label: t('nav.insights') },
    { to: '/events/list-your-event', label: t('nav.listYourEvent') },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <LocalizedLink to="/" className="flex items-center" data-testid="header-logo-link">
            <img
              src="/logo-header.png"
              alt="InternationalVenues.com® by Jigsaw Conferences Ltd"
              className="h-10 w-auto object-contain"
              data-testid="header-logo-image"
            />
          </LocalizedLink>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <LocalizedLink
                key={link.to}
                to={link.to}
                className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
                data-testid={`nav-link-${link.to === '/' ? 'home' : link.to.replace(/\//g, '-').replace(/^-/, '')}`}
              >
                {link.label}
              </LocalizedLink>
            ))}
            <a href="tel:08001214470" className="flex items-center space-x-2 text-orange-600 font-semibold hover:text-orange-700 transition-colors">
              <Phone className="w-4 h-4" />
              <span>{t('nav.call')}</span>
            </a>
            <LanguageSwitcher variant="desktop" />
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-orange-600"
            aria-label={t('nav.toggleMenu')}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="flex flex-col space-y-1 px-4 py-4">
            {navLinks.map((link) => (
              <LocalizedLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileMenuOpen(false)}
                className="px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-600 rounded-lg transition-colors"
              >
                {link.label}
              </LocalizedLink>
            ))}
            <a
              href="tel:08001214470"
              className="px-4 py-2 text-orange-600 font-semibold hover:bg-orange-50 rounded-lg transition-colors"
            >
              {t('nav.callMobile')}
            </a>
            <div className="border-t border-gray-100 mt-2 pt-2">
              <LanguageSwitcher variant="mobile" />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
